class MenuProductPreview {
    constructor() {
        this.init();
    }

    init() {
        this.initMainPreview();
    }

    initMainPreview() {
        // 处理主菜单产品预览切换
        const mainPreviewItems = document.querySelectorAll('.navigation__item--with-main-product-preview');

        mainPreviewItems.forEach((mainItem) => {
            const previewLinks = mainItem.querySelectorAll('.navigation__link--with-preview');
            const previewContents = mainItem.querySelectorAll('.navigation__preview-content');

            // 为每个子菜单链接添加hover事件
            previewLinks.forEach((link) => {
                link.addEventListener('mouseenter', () => {
                    const targetName = link.getAttribute('data-preview-trigger');
                    this.switchPreviewContent(targetName, previewContents, previewLinks);
                });
            });

            // 初始化：先隐藏所有预览内容
            previewContents.forEach((content) => {
                content.style.display = 'none';
            });

            // 默认激活第一个
            if (previewLinks.length > 0 && previewContents.length > 0) {
                const firstTrigger = previewLinks[0].getAttribute('data-preview-trigger');

                // 激活第一个链接
                previewLinks[0].classList.add('active');

                // 显示第一个预览内容
                const firstContent = Array.from(previewContents).find(content =>
                    content.getAttribute('data-preview-content') === firstTrigger
                );

                if (firstContent) {
                    firstContent.style.display = 'block';
                } else {
                    // 如果找不到匹配的内容，显示第一个可用的内容
                    if (previewContents.length > 0) {
                        previewContents[0].style.display = 'block';
                    }
                }
            }
        });
    }

    switchPreviewContent(targetName, previewContents, previewLinks) {
        // 隐藏所有内容
        previewContents.forEach((content) => {
            content.style.display = 'none';
        });

        // 移除所有active状态
        previewLinks.forEach((link) => {
            link.classList.remove('active');
        });

        // 在当前预览内容中查找目标内容
        const targetContent = Array.from(previewContents).find(content =>
            content.getAttribute('data-preview-content') === targetName
        );

        if (targetContent) {
            targetContent.style.display = 'block';
        }

        // 在当前预览链接中激活对应链接
        const targetLink = Array.from(previewLinks).find(link =>
            link.getAttribute('data-preview-trigger') === targetName
        );

        if (targetLink) {
            targetLink.classList.add('active');
        }
    }


}

// 当DOM准备就绪时初始化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.menuProductPreview = new MenuProductPreview();
    });
} else {
    window.menuProductPreview = new MenuProductPreview();
}